import { Component, OnInit } from '@angular/core';
import { TIPO_EMPRESAS } from 'src/app/model/empresa';
import { BackendApiService } from 'src/app/services/backend-api.service';

@Component({
  selector: 'app-page-home',
  templateUrl: './page-home.component.html',
  styleUrls: ['./page-home.component.scss'],
})
export class PageHomeComponent implements OnInit {
  constructor(private backendApiService: BackendApiService) {}

  tipoEmpresaMantenedora = TIPO_EMPRESAS.MANTENEDORA;
  tipoEmpresaIncubada = TIPO_EMPRESAS.INCUBADA;

  ngOnInit(): void {}
}
